import { Box } from '@mui/material';

export const Logo = () => (
  <Box
    component="img"
    src="/logo.png"
    alt="3 corazones Logo"
    sx={{ 
      height: { xs: 60, md: 80 }, 
      objectFit: 'contain',
      mixBlendMode: 'multiply' // Mezcla el blanco con el fondo para que parezca transparente
    }}
  />
);
